import { Box, BoxProps, Text } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { Tooltip } from '@tiendanube/components';
import Skeleton from './Skeleton';
import './StatsDailyValueCard.scss';

export const STYLE_STATS_DAILY_VALUE_CARD: BoxProps = {
  boxShadow: '2',
  backgroundColor: 'neutral-background',
  borderColor: 'neutral-surface',
  borderStyle: 'solid',
  padding: '2',
  paddingRight: '4',
  paddingLeft: '4',
  display: 'flex',
  gap: '1',
  flexDirection: 'column',
};

interface StatsDailyValueCardProps {
  title: string;
  value: string;
  textTooltip?: string;
  border:
    | 'left'
    | 'right'
    | 'top'
    | 'bottom'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'none';
}

function StatsDailyValueCard({
  value,
  title,
  textTooltip,
  border,
}: StatsDailyValueCardProps) {
  return (
    <Box
      {...STYLE_STATS_DAILY_VALUE_CARD}
      data-style={`stratus--border-${border}-stats-daily`}
    >
      <Box display="flex" gap="2">
        <Text fontSize="caption">{title}</Text>
        {!!textTooltip && (
          <Tooltip ariaLabel={textTooltip} labelIcon={InfoCircleIcon}>
            <Text fontSize="caption" color="neutral-surface">
              {textTooltip}
            </Text>
          </Tooltip>
        )}
      </Box>
      <Text>{value}</Text>
    </Box>
  );
}

StatsDailyValueCard.Skeleton = Skeleton;

export default StatsDailyValueCard;
